<script setup>
import {} from 'vue'
import { t, fm } from '@/i18n'
import { randNumber, resetHtml } from '@/common/core'
import { userModel } from '@/model/user'
import { goodsModel } from '@/model/task'
import { noticeModel } from '@/model/article'
import BannerWidget from '@/components/pages/home/BannerWidget.vue'

const { memberRef } = userModel(true)
const { goodsListRef } = goodsModel(true)
const { noticeShowRef, noticeDataRef } = noticeModel(false)
</script>

<template>
  <UiPage hideHeader class="bg-default">
    <section class="px-3 pt-3 pb-2 flex items-center">
      <router-link to="/user" class="w-1/2 flex items-center">
        <div class="w-8 h-8 bg-gray-light rounded-full overflow-hidden flex items-center justify-center flex-shrink-0">
          <nut-image v-if="memberRef.head_portrait" :src="memberRef.head_portrait" fit="cover" class="w-full h-full"></nut-image>
          <svg v-else class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"/>
          </svg>
        </div>
        <div class="px-2 flex-1 overflow-hidden">
          <p class="text-sm truncate">{{t('你好')}}&nbsp;{{memberRef.username}}</p>
        </div>
      </router-link>
      <div class="w-1/2 flex justify-end">
        <router-link to="/set_language" class="max-w-full h-6 pl-3 pr-2 bg-gray-light rounded-full flex items-center">
          <!-- <svg class="w-4 h-4" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>
          </svg>
          <span class="ml-1 text-xs">{{t('位置、中心')}}</span> -->
          <span class="mr-1 text-xs">{{t('title')}}</span>
          <IconArrowDownS class="w-4 h-4" fill="currentColor" />
        </router-link>
        <router-link to="/messages" class="pl-3 h-6 flex items-center">
          <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V18H18V10ZM20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"></path>
          </svg>
        </router-link>
      </div>
    </section>
    <BannerWidget />
    <!-- <section class="p-3">
      <div class="p-2 rounded-xl bg-gray-light flex items-center">
        <svg class="w-9 h-9 flex-shrink-0" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM14 19H20V5H8V7.12729C8.23444 7.12729 8.46888 7.20938 8.65718 7.37355L13.6572 11.733C13.875 11.9229 14 12.1978 14 12.4868V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"></path>
        </svg>
        <div class="pl-3 flex-1 overflow-hidden">
          <h5 class="text-base font-bold">Hotels in Canada</h5>
          <p class="text-xs">Search engine had over <b class="text-sm">300,000+</b>ad orders <b class="text-sm">19,235</b>from Canada!</p>
        </div>
      </div>
    </section> -->
    <section class="p-3">
      <router-link to="/invite" class="p-2 rounded-xl bg-gray-light flex items-center">
        <svg class="w-9 h-9 flex-shrink-0" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 20C22.866 20 26 16.866 26 13C26 9.13401 22.866 6 19 6C15.134 6 12 9.13401 12 13C12 16.866 15.134 20 19 20Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 40.8V42H34V40.8C34 36.3196 34 34.0794 33.1281 32.3681C32.3611 30.8628 31.1372 29.6389 29.6319 28.8719C27.9206 28 25.6804 28 21.2 28H16.8C12.3196 28 10.0794 28 8.36808 28.8719C6.86278 29.6389 5.63893 30.8628 4.87195 32.3681C4 34.0794 4 36.3196 4 40.8Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M38 13V25V13Z" fill="none"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M32 19H44H32Z" fill="none"/>
          <path d="M38 13V25M32 19H44" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="pl-3 flex-1 overflow-hidden">
          <h5 class="text-base font-bold">{{t('邀请好友')}}</h5>
          <p class="text-xs">{{t('邀请好友赚取佣金')}}</p>
        </div>
      </router-link>
    </section>
    <section class="p-3 mt-3">
      <h3>{{t('酒店')}}</h3>
      <ul>
        <li v-for="(item,index) in goodsListRef" :key="index" class="mb-3 block">
          <p class="text-xs leading-6 line-clamp-2">
            <span class="align-middle">{{randNumber(4.5, 5).toFixed(1)}}</span>
            <IconStar class="w-4 h-4 mx-1 text-third inline-block align-middle" />
            <span class="ml-1 font-medium inline-block align-middle">{{fm(item.price)}}</span>
            <span class="font-medium align-middle">&nbsp;·&nbsp;{{item.title}}</span>
          </p>
          <p class="text-xs">
            <svg class="w-3 h-3 me-1 opacity-50 inline-block align-middle" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"></path>
            </svg>
            <span class="align-middle">{{item.country}}</span>
          </p>
          <nut-image :src="item.img" fit="cover" class="w-full h-[120px] sm:h-[140px] md:h-[160px] mt-2 transition-all duration-300"></nut-image>
        </li>
      </ul>
    </section>

    <nut-popup v-model:visible="noticeShowRef" :style="{
      width: 'calc(100% - 32px)',
      maxWidth: 'calc(500px - 32px)',
      height: '70%',
      overflow: 'hidden',
      backgroundColor: 'transparent'
    }" teleport="#app">
      <div class="w-full h-full flex flex-col">
        <section class="w-full pb-4 bg-default text-default rounded-xl flex-1 overflow-hidden flex flex-col">
          <div class="w-full py-3 px-3 mb-2 ctx-third flex-shrink-0">
            <p class="text-lg text-center font-bold">{{t('公告')}}</p>
          </div>
          <div class="p-3 text-sm flex-1 overflow-y-auto">
              <article v-html="resetHtml(noticeDataRef.content)"></article>
          </div>
        </section>
        <button @click="noticeShowRef = false" class="w-10 h-10 mt-3 mx-auto rounded-full border border-white flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-white" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"></path>
          </svg>
        </button>
      </div>
    </nut-popup>
  </UiPage>
</template>